// Tek kaynak: tüm duyurular burada. is_special = true -> SpecialAnnouncements
// false -> PressAnnouncements. link/link_tr detay sayfası slug'larıdır.

export const Announcements = [
    {
      is_special: true,
      date: "23.07.2025",
      title: "Share Buyback Disclosure",
      title_tr: "Özel Durum Açıklaması: Pay Geri Alımı", 
      link: "share-buyback-disclosure",
      link_tr: "pay-geri-alimi-ozel-durum",
      external_link_tr:"https://www.kap.org.tr/tr", 
      body: `
        <p>We disclosed the initiation of a share buyback program...</p>
      `,
      body_tr: `
        <p>Şirketimiz pay geri alım programı başlatıldığını kamuya duyurmuştur...</p>
      `,
    },
    // {
    //   is_special: true,
    //   date: "26.07.2025",
    //   title: "deneme",
    //   title_tr: "Özel Durum Açıklaması deneme", 
    //   link: "share-buyback-ss",
    //   link_tr: "pay-geri-alimi-ozel-asd",
    //   body: `
    //     <p>We disclosed</p>
    //   `,
    //   body_tr: `
    //     <p>deneme...</p>
    //   `,
    // },
    {
      is_special: false,
      date: "15.07.2025",
      title: "Press Release: New Facility Opening",
      title_tr: "Basın Duyurusu: Yeni Tesis Açılışı",
      link: "new-facility-opening",
      link_tr: "yeni-tesis-acilisi",
      body: `
        <p>Our new facility is operational as of July 2025...</p>
      `,
      body_tr: `
        <p>Temmuz 2025 itibarıyla yeni tesisimiz faaliyete geçmiştir...</p>
      `,
    },
    
  ];
  